export default __webpack_public_path__ + "static/media/GoldSilver_Logo.9a469a14.png";